import { render, staticRenderFns } from "./EmployerRegistration.vue?vue&type=template&id=542bd7a0&scoped=true&"
import script from "./EmployerRegistration.vue?vue&type=script&lang=ts&"
export * from "./EmployerRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerRegistration.vue?vue&type=style&index=0&id=542bd7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542bd7a0",
  null
  
)

component.options.__file = "EmployerRegistration.vue"
export default component.exports